module.exports = __webpack_public_path__ + "img/gold_full.deb5e2a0.svg";